import { createTheme } from '@mui/material/styles';
import { palette } from './palette';

// MUI module augmentations for our custom palette/theme members live in a
// dedicated, side-effect-only module. Imported here so the augmented types are
// part of the program wherever the theme is used.
import './augmentations.types';

const DEFAULT_FONT = '"Lato", sans-serif';
const HEADER_HEIGHT = 64;
const PAGE_PADDING = 40;
const FOOTER_HEIGHT = 75;
const SMALL_SCREEN_FOOTER_HEIGHT = 132;

export const theme = createTheme({
  components: {
    MuiStepIcon: {
      styleOverrides: {
        root: {
          color: '#939393',
          '&.Mui-completed': {
            color: '#14A5B2',
          },
          '&.Mui-active': {
            color: '#14A5B2',
          },
        },
        active: {},
        completed: {},
      },
    },
  },
  typography: {
    fontFamily: DEFAULT_FONT,
  },
  measurements: {
    headerHeight: HEADER_HEIGHT,
    pagePadding: PAGE_PADDING,
    footerHeight: FOOTER_HEIGHT,
    smallScreenFooterHeight: SMALL_SCREEN_FOOTER_HEIGHT,
  },
  defaultLayout: {
    root: {
      display: 'block',
      height: '100%',
      overflow: 'hidden',
    },
    title: {
      fontSize: 30,
      fontFamily: DEFAULT_FONT,
    },
    container: {
      display: 'block',
      position: 'absolute',
      left: 0,
      top: HEADER_HEIGHT,
      right: 0,
      bottom: 0,
    },
    content: {
      padding: PAGE_PADDING,
    },
  },
  palette: {
    mainaccent: '#18838c',
    secondaryaccent: '#e88126',
    darkaccent: '#20547b',
    darkaccentLight: '#4c7695',
    darkaccentDark: '#163a56',
    lightgray: '#fafafc',
    gray: '#eceff1',
    darkgray: '#939393',
    favorable: '#55e0ec',
    unfavorable: '#f1b47c',

    ...palette,
  },
});
